var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessEmblem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 81,
    viewBox: "0 0 68 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 57.5221V13.7453C68 11.641 67.1235 9.63503 65.5822 8.20703C64.0408 6.77903 61.9745 6.05747 59.8778 6.21236L59.8589 6.21614C50.728 6.99814 43.7581 5.81569 39.2021 2.01525C36.2289 -0.731195 31.6804 -0.655627 28.8509 2.15126C24.4724 6.09148 17.5591 7.28149 8.27715 6.34082L8.25824 6.33705C6.13513 6.14438 4.04596 6.84702 2.48574 8.27124C0.925516 9.69547 0.0378147 11.7128 0.0378147 13.8246C3.68932e-05 23.5599 0 47.4279 0 57.5221C0 61.7797 2.38753 65.6821 6.1842 67.6164C12.1946 70.6839 23.256 76.3242 28.8509 79.1764C32.0846 80.8273 35.9154 80.8273 39.1491 79.1764L61.8158 67.6164C65.6125 65.6821 68 61.7797 68 57.5221ZM19.9958 42.4564L27.5513 50.0119C29.0247 51.489 31.4198 51.489 32.8931 50.0119L48.0042 34.9008C49.4776 33.4275 49.4776 31.0324 48.0042 29.559C46.5309 28.0857 44.1358 28.0857 42.6624 29.559L30.2222 41.9992L25.3376 37.1146C23.8642 35.6413 21.4691 35.6413 19.9958 37.1146C18.5224 38.5879 18.5224 40.983 19.9958 42.4564Z",
    fill: "url(#paint0_linear_949_113)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_949_113",
    x1: 73.3224,
    y1: -7.89115,
    x2: 14.7218,
    y2: 86.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEmblem);
export default __webpack_public_path__ + "static/media/success-emblem.9bc1ed160373b4b5530084bb6ede1b68.svg";
export { ForwardRef as ReactComponent };